import React, { useEffect, useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonInput,
  IonTextarea,
  IonButton
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ProfilePublicDto } from '../api';
import useAstroApiClient from '../hooks/useAstroApiClient';

const EditProfile: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [displayName, setDisplayName] = useState('');
  const [bio, setBio] = useState('');
  const api = useAstroApiClient();

  useEffect(() => {
    const load = async () => {
      const user = await api.apiUsersAuth();
      if (user?.id) {
        const data = await api.apiSocialProfile(user.id);
        if (data) {
          setDisplayName(data.displayName ?? '');
          setBio(data.bio ?? '');
        }
      }
    };
    load();
  }, [api]);

  const handleSave = async () => {
    await api.apiSocialProfileMe(new ProfilePublicDto({ displayName: displayName, bio: bio }));
    history.goBack();
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar className="app-safe-toolbar">
          <IonTitle>{t('editProfile')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding app-safe-form-content">
        <IonItem>
          <IonLabel position="stacked">{t('name')}</IonLabel>
          <IonInput
            type="text"
            value={displayName}
            onIonChange={e => setDisplayName(e.detail.value ?? '')}
          />
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">{t('bio')}</IonLabel>
          <IonTextarea
            value={bio}
            onIonChange={e => setBio(e.detail.value ?? '')}
          />
        </IonItem>
        <IonButton expand="block" onClick={handleSave}>
          {t('save')}
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default EditProfile;


